import apiClient from './apiClient';

/**
 * Upload an image to Cloudinary via backend.
 * returns { url, publicId }
 */
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);

  const { data } = await apiClient.post('/api/uploads/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

/**
 * Upload a video to Cloudinary via backend.
 * returns { url, publicId }
 */
export const uploadVideo = async (file) => {
  const formData = new FormData();
  formData.append('video', file);

  const { data } = await apiClient.post('/api/uploads/video', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    timeout: 0, // No timeout for video uploads
  });
  return data;
};
